import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
const testimonials = [{
  quote: 'Llevaba 5 años usando corticoides. En 10 días con este protocolo, mi piel está mejor que nunca. No puedo creer lo simple que fue.',
  author: 'María G.',
  role: 'Paciente verificada'
}, {
  quote: 'Lo que más me gustó es que no te obliga a comprar productos caros. Te enseña a usar lo que realmente funciona. Es educación pura.',
  author: 'Carlos R.',
  role: 'Paciente verificado'
}, {
  quote: 'Sentí paz. Por primera vez alguien me explicó por qué me pasaba esto y cómo solucionarlo sin agresividad. Gracias infinitas.',
  author: 'Elena M.',
  role: 'Paciente verificada'
}];
export function TestimonialsSection() {
  return <section className="py-24 bg-sage-50" data-id="element-160">
      <div className="max-w-6xl mx-auto px-4" data-id="element-161">
        <FadeIn className="text-center mb-16" data-id="element-162">
          <h2 className="font-serif text-3xl md:text-4xl text-warm-900 mb-6" data-id="element-163">
            Lo que puedes esperar
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-164">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.15} className="bg-white p-8 rounded-2xl shadow-sm border border-sage-100/50" data-id="element-165">
              <div className="flex gap-1 mb-4" data-id="element-166">
                {[...Array(5)].map((_, starI) => <Star key={starI} className="w-4 h-4 fill-sage-400 text-sage-400" data-id="element-167" />)}
              </div>
              <p className="text-warm-700 text-lg italic mb-6 leading-relaxed" data-id="element-168">
                "{t.quote}"
              </p>
              <div data-id="element-169">
                <p className="font-serif font-bold text-warm-900" data-id="element-170">{t.author}</p>
                <p className="text-sm text-sage-600" data-id="element-171">{t.role}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}